import { Priority } from '../_utils';

export interface WorkItemPriority {
  id: number;
  name: string;
  icon: string;
  defaultFlg: boolean;
  code: Priority;
}
